export const translations = {
  en: {
    nav: {
      home: "Home", about: "About Us", fleet: "Our Fleet", services: "Services",
      driver: "Join as Driver", contact: "Contact",
      contactCta: "Contact Us", driverCta: "Become a Driver", journal: "Journal"
    },
    blog: {
      eyebrow: "Journal", title: "Notes from the road",
      sub: "Short reads on premium electric mobility in Antwerp.",
      readMore: "Read", back: "All articles", minRead: "min read"
    },
    whatsapp: {
      aria: "Chat on WhatsApp",
      message: "Hello MIRAL GROUP, I would like to book a ride."
    },
    hero: {
      badge: "100% Electric · Zero Emission · Antwerp VIP Chauffeur",
      line1: "Driven by Innovation.",
      line2: "Designed for Your Journey.",
      sub: "MIRAL GROUP redefines premium mobility in Antwerp — a 100% electric Tesla fleet, protocol-trained chauffeurs and absolute discretion.",
      ctaContact: "Contact Us",
      ctaDriver: "Become a Driver",
      stats: [
        { v: "100%", l: "Electric fleet" },
        { v: "629 km", l: "Max range WLTP" },
        { v: "4.4s", l: "0–100 km/h" },
        { v: "24/24", l: "Concierge dispatch" }
      ]
    },
    marquee: ["Brussels Airport", "EU District", "Grote Markt", "Zero-Emission Luxury", "Tesla Model 3", "Tesla Model Y", "24/24 Concierge"],
    home: {
      fleetEyebrow: "Our Fleet",
      fleetTitle: "Tesla. Silence is the new luxury.",
      fleetSub: "Two models, one standard: uncompromising electric comfort for the discerning traveller.",
      fleetCta: "Explore the fleet",
      servicesEyebrow: "Services",
      servicesTitle: "Every journey, engineered.",
      servicesSub: "From EU institutional transfers to private evenings, every ride follows the MIRAL protocol.",
      estEyebrow: "Fare estimator",
      estTitle: "Estimate your ride",
      estSub: "Select a route and a vehicle for an indicative fare. Final quote on request.",
      estNote: "Indicative fares — the final quote is confirmed by our concierge.",
      estCta: "Request this ride",
      routes: {
        bru: "Antwerp ↔ Brussels Airport (BRU)",
        crl: "Antwerp ↔ Charleroi Airport (CRL)",
        hourly: "Hourly booking (min. 3h)"
      },
      vehicle3: "Model 3",
      vehicleY: "Model Y",
      hourlyUnit: "/hour",
      bannerEyebrow: "Careers",
      bannerTitle: "Drive the future of Antwerp.",
      bannerSub: "Join a premium chauffeur house. Tesla provided, premium clientele, flexible shifts.",
      bannerCta: "Apply now"
    },
    about: {
      eyebrow: "About Us",
      title: "Antwerp, elevated.",
      lead: "MIRAL GROUP was built on a simple conviction: moving through a capital should feel effortless, silent and entirely personal.",
      p1: "From the Grand-Place to the European Quarter, our chauffeurs know every street, every entrance, every timing. Behind the wheel of a 100% electric Tesla fleet, they follow one standard: yours.",
      p2: "No combustion, no noise, no compromise. Just the quiet confidence of a house that treats every journey as a signature.",
      missionEyebrow: "Our mission",
      missionTitle: "Zero emission. Full attention.",
      missionText: "We operate one of the first all-Tesla chauffeur fleets in Antwerp. Every ride is a step towards cleaner air in the city we love — without giving up an inch of comfort.",
      standardsEyebrow: "Executive standards",
      standards: [
        { t: "Protocol-trained chauffeurs", d: "Multilingual, discreet, trained to diplomatic standards." },
        { t: "Real-time dispatch, 24/24", d: "Our concierge monitors every flight and every road." },
        { t: "Absolute privacy", d: "What is said on board stays on board." },
        { t: "Immaculate, every time", d: "Each Tesla is detailed and inspected before every ride." }
      ]
    },
    fleetPage: {
      eyebrow: "Our Fleet",
      title: "Two silhouettes. One signature.",
      sub: "Explore the MIRAL fleet in detail — range, pace and comfort, engineered around you.",
      bookCta: "Book this model",
      compareEyebrow: "Side by side",
      compareTitle: "Choose your silhouette",
      labels: { range: "Range · WLTP", accel: "0–100 km/h", seats: "Passengers", luggage: "Luggage", drive: "Drivetrain", features: "Signature features" },
      models: {
        m3: {
          name: "Tesla Model 3 Highland",
          category: "Executive Sedan",
          drive: "Dual Motor AWD",
          desc: "The Highland refresh of the executive benchmark — sculpted, whisper-quiet and astonishingly quick. The definitive sedan for Antwerp.",
          features: ["Panoramic glass roof", "Premium audio", "Tri-zone climate", "Heated seats"]
        },
        my: {
          name: "Tesla Model Y Long Range",
          category: "Premium SUV",
          drive: "Dual Motor AWD",
          desc: "Space without compromise: a panoramic SUV for delegations, families and luggage-heavy arrivals, with the same silent MIRAL protocol on board.",
          features: ["Panoramic glass roof", "Premium audio", "HEPA filter", "Heated rear seats"]
        }
      }
    },
    servicesPage: {
      eyebrow: "Services",
      title: "Every journey, engineered.",
      sub: "Four disciplines, one protocol: absolute precision from the first message to the final doorstep.",
      items: [
        { id: "airport", title: "Airport Chauffeur", desc: "Meet & greet at Brussels Airport (BRU) and Charleroi (CRL), with live flight tracking and waiting time included." },
        { id: "eu", title: "Diplomatic & EU Transport", desc: "Discreet transport for delegations and institutions around the European Quarter, with multilingual protocol chauffeurs." },
        { id: "corporate", title: "Corporate Subscriptions", desc: "Dedicated vehicles and priority dispatch for executives and teams, with consolidated monthly invoicing." },
        { id: "events", title: "Weddings & VIP Events", desc: "White-glove Tesla service for private celebrations, galas and red-carpet evenings across Belgium." }
      ],
      processEyebrow: "The protocol",
      processTitle: "Three steps. Zero friction.",
      steps: [
        { title: "Book in seconds", desc: "Online, by phone or via your concierge — 24/24." },
        { title: "Meet your chauffeur", desc: "Flight tracking, name board, luggage handled." },
        { title: "Arrive refreshed", desc: "Silent, smooth, right on time." }
      ],
      ctaTitle: "Tell us where and when.",
      ctaSub: "Our concierge answers within minutes, day or night.",
      ctaButton: "Contact Us"
    },
    driver: {
      eyebrow: "Careers",
      title: "Take the wheel of your career.",
      sub: "Join the house that made Antwerp silent. Tesla provided, premium clientele, flexible shifts.",
      benefitsTitle: "Why MIRAL",
      benefits: [
        "A Tesla, provided and maintained by us",
        "Premium clientele: embassies, EU institutions, luxury hotels",
        "Flexible shifts that fit your life",
        "Continuous training, transparent earnings"
      ],
      reqTitle: "Requirements",
      reqs: [
        "Valid driving licence (category B)",
        "Professional taxi or chauffeur licence — or the willingness to obtain one",
        "Fluent in French and/or Dutch; English is an asset",
        "Impeccable conduct and professional presentation",
        "Comfortable representing the MIRAL standard"
      ],
      formTitle: "Driver application",
      formSub: "Complete the form below — our team replies within 48 hours.",
      form: {
        fullName: "Full name",
        email: "Email",
        phone: "Phone",
        city: "City",
        license: "Driving licence number",
        experience: "Years of experience",
        languages: "Languages spoken",
        languagesPh: "e.g. French, Dutch, English",
        notes: "Notes (optional)",
        notesPh: "Availability, certifications, anything else…",
        submit: "Submit application",
        successTitle: "Application received",
        successBody: "Thank you! Our team will contact you within 48 hours.",
        ref: "Reference",
        again: "Submit another application"
      },
      faqTitle: "Frequently asked questions",
      faq: [
        { q: "Do I need my own vehicle?", a: "No. Your Tesla is provided and maintained by MIRAL GROUP." },
        { q: "Which languages do I need?", a: "French or Dutch is required; English is a strong asset for our international clientele." },
        { q: "What is the selection process?", a: "Apply via the form, then an interview and a driving assessment with our operations team." },
        { q: "Can I choose my shifts?", a: "Yes. We build schedules around your availability." }
      ]
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's plan your journey.",
      sub: "Tell us where and when — our concierge confirms every detail.",
      infoTitle: "Direct contact",
      office: "Office",
      phoneLabel: "Phone",
      emailLabel: "Email",
      dispatchLabel: "Dispatch",
      dispatchValue: "24/24 — phone & email",
      mapTitle: "Find us in Antwerp",
      mapSub: "City office & airport meet-and-greet zone.",
      markerHqTitle: "MIRAL GROUP — City Office",
      markerHqSub: "Antwerp City Centre",
      markerAirportTitle: "Brussels Airport (BRU)",
      markerAirportSub: "Meet & greet zone",
      formTitle: "Request a ride",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        service: "Service type",
        pickup: "Pick-up location",
        pickupPh: "Address, hotel or terminal",
        dest: "Destination (optional)",
        destPh: "Address or airport",
        datetime: "Pick-up date & time",
        notes: "Message (optional)",
        notesPh: "Passengers, luggage, special requests…",
        submit: "Send request",
        successTitle: "Request sent",
        successBody: "Our concierge will confirm the details shortly.",
        ref: "Reference",
        again: "Send another request"
      },
      serviceOptions: {
        airport: "Airport transfer (BRU / CRL)",
        eu: "Diplomatic & EU transport",
        corporate: "Corporate subscription",
        events: "Weddings & VIP events",
        other: "Other request"
      }
    },
    auth: {
      signIn: "Sign in", createAccount: "Create account", welcomeBack: "Welcome back", joinUs: "Join MIRAL GROUP",
      loginSub: "Access your bookings and payments.", registerSub: "One account for bookings, receipts and priority support.",
      fullName: "Full name", email: "Email", phone: "Phone (optional)", password: "Password", passwordHint: "At least 8 characters",
      loginBtn: "Sign in", registerBtn: "Create my account",
      noAccount: "No account yet? Create one", haveAccount: "Already have an account? Sign in",
      googleBtn: "Continue with Google", or: "or",
      myAccount: "My account", myRequests: "My ride requests", noRequests: "No ride requests yet — book your first ride.",
      logout: "Sign out", hello: "Hello", bookCta: "Book a ride",
      errors: { invalidCreds: "Invalid email or password", emailUsed: "An account with this email already exists", weakPassword: "Password must be at least 8 characters", nameRequired: "Please enter your name" },
      forgotLink: "Forgot password?", forgotTitle: "Reset your password", forgotSub: "Enter your email — we'll send you a reset link.",
      forgotBtn: "Send reset link", forgotSent: "If an account exists for this email, a reset link is on its way.",
      newPassword: "New password", confirmPassword: "Confirm password", resetBtn: "Save new password",
      resetDone: "Password updated — you can sign in now.", mismatch: "Passwords don't match",
      invalidLink: "This reset link is invalid or expired. Request a new one.", backToLogin: "Back to sign in",
      cols: ["Date", "Service", "Pick-up", "Destination", "Status", "Payment"]
    },
    admin: {
      title: "Bookings & applications", loginTitle: "Admin panel", loginSub: "Restricted to MIRAL GROUP staff.",
      email: "Email", password: "Password", signIn: "Sign in", refresh: "Refresh", backHome: "← Back to website",
      empty: "No entries yet.", loading: "LOADING…",
      tabs: { drivers: "Driver applications", requests: "Ride requests", payments: "Payments" },
      actions: { approve: "Approve", reject: "Reject", decisionSent: "Applicant notified", colActions: "Actions" },
      cols: {
        drivers: ["Received", "Name", "Contact", "City", "Licence", "Exp.", "Languages", "Status", "Actions"],
        contacts: ["Received", "Name", "Contact", "Service", "Pickup", "Destination", "When", "Payment"],
        payments: ["Date", "Session", "Booking ref", "Amount", "Status"]
      }
    },
    pay: {
      depositTitle: "Confirm your booking",
      depositBody: "Pay the €20 booking deposit to secure your ride — the remaining balance is settled with your chauffeur.",
      depositBtn: "Pay €20 deposit",
      paying: "Redirecting to secure checkout…",
      processing: "Verifying your payment…",
      successTitle: "Payment confirmed",
      successBody: "Your booking deposit has been received. Our concierge will confirm the final details.",
      cancelTitle: "Payment cancelled",
      cancelBody: "No charge was made. Your ride request is saved — you can pay the deposit anytime.",
      failed: "We could not confirm this payment yet. If you completed it, check back in a minute.",
      backHome: "Back to home"
    },
    errors: {
      required: "This field is required",
      email: "Please enter a valid email address",
      phone: "Please enter a valid phone number",
      license: "Please enter at least 4 characters",
      experience: "Enter a number between 0 and 60",
      generic: "Something went wrong. Please try again."
    },
    footer: {
      tagline: "Premium electric chauffeur service. Antwerp.",
      navigate: "Navigate",
      servicesTitle: "Services",
      contactTitle: "Contact",
      rights: "All rights reserved."
    }
  },

  fr: {
    nav: {
      home: "Accueil", about: "À Propos", fleet: "Notre Flotte", services: "Services",
      driver: "Devenir Chauffeur", contact: "Contact",
      contactCta: "Nous contacter", driverCta: "Devenir chauffeur", journal: "Journal"
    },
    blog: {
      eyebrow: "Journal", title: "Notes de route",
      sub: "Brèves lectures sur la mobilité électrique premium à Anvers.",
      readMore: "Lire", back: "Tous les articles", minRead: "min de lecture"
    },
    whatsapp: {
      aria: "Discuter sur WhatsApp",
      message: "Bonjour MIRAL GROUP, je souhaite réserver une course."
    },
    hero: {
      badge: "100% électrique · Zéro émission · Chauffeur VIP Anvers",
      line1: "Portés par l'innovation.",
      line2: "Conçus pour votre trajet.",
      sub: "MIRAL GROUP réinvente la mobilité premium à Anvers : une flotte 100% électrique Tesla, des chauffeurs formés au protocole et une discrétion absolue.",
      ctaContact: "Nous contacter",
      ctaDriver: "Devenir chauffeur",
      stats: [
        { v: "100%", l: "Flotte électrique" },
        { v: "629 km", l: "Autonomie max WLTP" },
        { v: "4,4s", l: "0–100 km/h" },
        { v: "24/24", l: "Conciergerie dédiée" }
      ]
    },
    marquee: ["Aéroport de Bruxelles", "Quartier européen", "Grote Markt", "Luxe zéro émission", "Tesla Model 3", "Tesla Model Y", "Conciergerie 24/24"],
    home: {
      fleetEyebrow: "Notre flotte",
      fleetTitle: "Tesla. Le silence est le nouveau luxe.",
      fleetSub: "Deux modèles, une exigence : un confort électrique sans compromis pour le voyageur exigeant.",
      fleetCta: "Découvrir la flotte",
      servicesEyebrow: "Services",
      servicesTitle: "Chaque trajet, travaillé dans le détail.",
      servicesSub: "Des transferts institutionnels européens aux soirées privées, chaque course suit le protocole MIRAL.",
      estEyebrow: "Estimateur",
      estTitle: "Estimez votre trajet",
      estSub: "Choisissez un itinéraire et un véhicule pour un tarif indicatif. Devis final sur demande.",
      estNote: "Tarifs indicatifs — le devis final est confirmé par notre conciergerie.",
      estCta: "Demander ce trajet",
      routes: {
        bru: "Anvers ↔ Aéroport de Bruxelles (BRU)",
        crl: "Anvers ↔ Aéroport de Charleroi (CRL)",
        hourly: "Mise à disposition (min. 3h)"
      },
      vehicle3: "Model 3",
      vehicleY: "Model Y",
      hourlyUnit: "/heure",
      bannerEyebrow: "Carrières",
      bannerTitle: "Conduisez le futur d'Anvers.",
      bannerSub: "Rejoignez une maison de chauffeurs premium. Tesla fournie, clientèle haut de gamme, horaires flexibles.",
      bannerCta: "Postuler"
    },
    about: {
      eyebrow: "À propos",
      title: "Anvers, avec élégance.",
      lead: "MIRAL GROUP repose sur une conviction simple : traverser une capitale doit être fluide, silencieux et entièrement personnel.",
      p1: "De la Grand-Place au Quartier européen, nos chauffeurs connaissent chaque rue, chaque entrée, chaque horaire. Au volant d'une flotte Tesla 100% électrique, ils ne suivent qu'une seule norme : la vôtre.",
      p2: "Aucune combustion, aucun bruit, aucun compromis. Simplement l'assurance tranquille d'une maison qui traite chaque trajet comme une signature.",
      missionEyebrow: "Notre mission",
      missionTitle: "Zéro émission. Attention totale.",
      missionText: "Nous opérons l'une des premières flottes de chauffeurs entièrement Tesla d'Anvers. Chaque trajet est un pas vers un air plus pur dans la ville que nous aimons — sans rien céder au confort.",
      standardsEyebrow: "Standards executive",
      standards: [
        { t: "Chauffeurs formés au protocole", d: "Multilingues, discrets, formés aux standards diplomatiques." },
        { t: "Dispatch temps réel, 24/24", d: "Notre conciergerie surveille chaque vol et chaque route." },
        { t: "Confidentialité absolue", d: "Ce qui se dit à bord reste à bord." },
        { t: "Impeccable, à chaque fois", d: "Chaque Tesla est préparée et inspectée avant chaque trajet." }
      ]
    },
    fleetPage: {
      eyebrow: "Notre flotte",
      title: "Deux silhouettes. Une signature.",
      sub: "Découvrez la flotte MIRAL en détail — autonomie, rythme et confort, conçus autour de vous.",
      bookCta: "Réserver ce modèle",
      compareEyebrow: "Côte à côte",
      compareTitle: "Choisissez votre silhouette",
      labels: { range: "Autonomie · WLTP", accel: "0–100 km/h", seats: "Passagers", luggage: "Bagages", drive: "Motorisation", features: "Équipements signature" },
      models: {
        m3: {
          name: "Tesla Model 3 Highland",
          category: "Berline Executive",
          drive: "Dual Motor AWD",
          desc: "La Highland, la référence absolue de la berline executive — sculptée, silencieuse et d'une vivacité étonnante. La berline bruxelloise par excellence.",
          features: ["Toit panoramique en verre", "Audio premium", "Climatisation tri-zone", "Sièges chauffants"]
        },
        my: {
          name: "Tesla Model Y Long Range",
          category: "SUV Premium",
          drive: "Dual Motor AWD",
          desc: "L'espace sans compromis : un SUV panoramique pour les délégations, les familles et les bagages nombreux, avec le même protocole MIRAL silencieux.",
          features: ["Toit panoramique en verre", "Audio premium", "Filtre HEPA", "Sièges arrière chauffants"]
        }
      }
    },
    servicesPage: {
      eyebrow: "Services",
      title: "Chaque trajet, travaillé dans le détail.",
      sub: "Quatre disciplines, un protocole : une précision absolue du premier message jusqu'au pas de porte final.",
      items: [
        { id: "airport", title: "Chauffeur Aéroport", desc: "Accueil à l'aéroport de Bruxelles (BRU) et Charleroi (CRL), avec suivi de vol en direct et temps d'attente inclus." },
        { id: "eu", title: "Transport Diplomatique & UE", desc: "Transport discret pour délégations et institutions autour du Quartier européen, avec chauffeurs multilingues formés au protocole." },
        { id: "corporate", title: "Abonnements Corporate", desc: "Véhicules dédiés et dispatch prioritaire pour dirigeants et équipes, avec facturation mensuelle consolidée." },
        { id: "events", title: "Mariages & Événements VIP", desc: "Service Tesla en gants blancs pour célébrations privées, galas et soirées tapis rouge à travers la Belgique." }
      ],
      processEyebrow: "Le protocole",
      processTitle: "Trois étapes. Zéro friction.",
      steps: [
        { title: "Réservez en quelques secondes", desc: "En ligne, par téléphone ou via votre conciergerie — 24/24." },
        { title: "Rencontrez votre chauffeur", desc: "Suivi de vol, pancarte à votre nom, bagages pris en charge." },
        { title: "Arrivez reposé", desc: "Silence, douceur, à l'heure exacte." }
      ],
      ctaTitle: "Dites-nous où et quand.",
      ctaSub: "Notre conciergerie répond en quelques minutes, jour et nuit.",
      ctaButton: "Nous contacter"
    },
    driver: {
      eyebrow: "Carrières",
      title: "Prenez le volant de votre carrière.",
      sub: "Rejoignez la maison qui a rendu Anvers silencieuse. Tesla fournie, clientèle haut de gamme, horaires flexibles.",
      benefitsTitle: "Pourquoi MIRAL",
      benefits: [
        "Une Tesla, fournie et entretenue par nos soins",
        "Clientèle premium : ambassades, institutions européennes, hôtels de luxe",
        "Horaires flexibles qui s'adaptent à votre vie",
        "Formation continue, revenus transparents"
      ],
      reqTitle: "Conditions",
      reqs: [
        "Permis de conduire valide (catégorie B)",
        "Licence de taxi ou chauffeur professionnel — ou la volonté de l'obtenir",
        "Courant en français et/ou néerlandais ; l'anglais est un atout",
        "Conduite irréprochable et présentation professionnelle",
        "À l'aise pour représenter le standard MIRAL"
      ],
      formTitle: "Candidature chauffeur",
      formSub: "Remplissez le formulaire ci-dessous — notre équipe répond sous 48 heures.",
      form: {
        fullName: "Nom complet",
        email: "E-mail",
        phone: "Téléphone",
        city: "Ville",
        license: "Numéro de permis de conduire",
        experience: "Années d'expérience",
        languages: "Langues parlées",
        languagesPh: "ex. français, néerlandais, anglais",
        notes: "Notes (facultatif)",
        notesPh: "Disponibilités, certifications, autres…",
        submit: "Envoyer ma candidature",
        successTitle: "Candidature reçue",
        successBody: "Merci ! Notre équipe vous contactera sous 48 heures.",
        ref: "Référence",
        again: "Envoyer une autre candidature"
      },
      faqTitle: "Questions fréquentes",
      faq: [
        { q: "Dois-je avoir mon propre véhicule ?", a: "Non. Votre Tesla est fournie et entretenue par MIRAL GROUP." },
        { q: "Quelles langues dois-je parler ?", a: "Le français ou le néerlandais est requis ; l'anglais est un atout majeur pour notre clientèle internationale." },
        { q: "Quel est le processus de sélection ?", a: "Postulez via le formulaire, puis un entretien et une évaluation de conduite avec notre équipe des opérations." },
        { q: "Puis-je choisir mes horaires ?", a: "Oui. Nous construisons les plannings autour de vos disponibilités." }
      ]
    },
    contact: {
      eyebrow: "Contact",
      title: "Planifions votre trajet.",
      sub: "Dites-nous où et quand — notre conciergerie confirme chaque détail.",
      infoTitle: "Contact direct",
      office: "Bureau",
      phoneLabel: "Téléphone",
      emailLabel: "E-mail",
      dispatchLabel: "Conciergerie",
      dispatchValue: "24/24 — téléphone & e-mail",
      mapTitle: "Trouvez-nous à Anvers",
      mapSub: "Bureau en ville et zone d'accueil à l'aéroport.",
      markerHqTitle: "MIRAL GROUP — Bureau",
      markerHqSub: "Centre d'Anvers",
      markerAirportTitle: "Aéroport de Bruxelles (BRU)",
      markerAirportSub: "Zone meet & greet",
      formTitle: "Demander une course",
      form: {
        name: "Nom complet",
        email: "E-mail",
        phone: "Téléphone",
        service: "Type de service",
        pickup: "Lieu de prise en charge",
        pickupPh: "Adresse, hôtel ou terminal",
        dest: "Destination (facultatif)",
        destPh: "Adresse ou aéroport",
        datetime: "Date & heure de prise en charge",
        notes: "Message (facultatif)",
        notesPh: "Passagers, bagages, demandes spéciales…",
        submit: "Envoyer la demande",
        successTitle: "Demande envoyée",
        successBody: "Notre conciergerie confirmera les détails sous peu.",
        ref: "Référence",
        again: "Envoyer une autre demande"
      },
      serviceOptions: {
        airport: "Transfert aéroport (BRU / CRL)",
        eu: "Transport diplomatique & UE",
        corporate: "Abonnement corporate",
        events: "Mariages & événements VIP",
        other: "Autre demande"
      }
    },
    auth: {
      signIn: "Se connecter", createAccount: "Créer un compte", welcomeBack: "Bon retour", joinUs: "Rejoignez MIRAL GROUP",
      loginSub: "Accédez à vos réservations et paiements.", registerSub: "Un compte pour vos réservations, reçus et assistance prioritaire.",
      fullName: "Nom complet", email: "E-mail", phone: "Téléphone (facultatif)", password: "Mot de passe", passwordHint: "8 caractères minimum",
      loginBtn: "Se connecter", registerBtn: "Créer mon compte",
      noAccount: "Pas encore de compte ? Créez-en un", haveAccount: "Déjà un compte ? Connectez-vous",
      googleBtn: "Continuer avec Google", or: "ou",
      myAccount: "Mon compte", myRequests: "Mes demandes de trajet", noRequests: "Aucune demande pour le moment — réservez votre premier trajet.",
      logout: "Se déconnecter", hello: "Bonjour", bookCta: "Réserver une course",
      errors: { invalidCreds: "E-mail ou mot de passe incorrect", emailUsed: "Un compte existe déjà avec cet e-mail", weakPassword: "Le mot de passe doit contenir au moins 8 caractères", nameRequired: "Veuillez saisir votre nom" },
      forgotLink: "Mot de passe oublié ?", forgotTitle: "Réinitialiser votre mot de passe", forgotSub: "Saisissez votre e-mail — nous vous enverrons un lien de réinitialisation.",
      forgotBtn: "Envoyer le lien", forgotSent: "Si un compte existe pour cet e-mail, un lien est en route.",
      newPassword: "Nouveau mot de passe", confirmPassword: "Confirmez le mot de passe", resetBtn: "Enregistrer",
      resetDone: "Mot de passe mis à jour — vous pouvez vous connecter.", mismatch: "Les mots de passe ne correspondent pas",
      invalidLink: "Ce lien est invalide ou expiré. Demandez-en un nouveau.", backToLogin: "Retour à la connexion",
      cols: ["Date", "Service", "Départ", "Destination", "Statut", "Paiement"]
    },
    admin: {
      title: "Réservations & candidatures", loginTitle: "Panneau admin", loginSub: "Réservé à l'équipe MIRAL GROUP.",
      email: "E-mail", password: "Mot de passe", signIn: "Se connecter", refresh: "Actualiser", backHome: "← Retour au site",
      empty: "Aucune entrée pour le moment.", loading: "CHARGEMENT…",
      tabs: { drivers: "Candidatures chauffeurs", requests: "Demandes de trajet", payments: "Paiements" },
      actions: { approve: "Approuver", reject: "Refuser", decisionSent: "Candidat notifié", colActions: "Actions" },
      cols: {
        drivers: ["Reçu", "Nom", "Contact", "Ville", "Permis", "Exp.", "Langues", "Statut", "Actions"],
        contacts: ["Reçu", "Nom", "Contact", "Service", "Départ", "Destination", "Quand", "Paiement"],
        payments: ["Date", "Session", "Réf. réservation", "Montant", "Statut"]
      }
    },
    pay: {
      depositTitle: "Confirmez votre réservation",
      depositBody: "Payez l'acompte de 20 € pour garantir votre trajet — le solde se règle avec votre chauffeur.",
      depositBtn: "Payer l'acompte de 20 €",
      paying: "Redirection vers le paiement sécurisé…",
      processing: "Vérification de votre paiement…",
      successTitle: "Paiement confirmé",
      successBody: "Votre acompte a bien été reçu. Notre conciergerie confirmera les détails finaux.",
      cancelTitle: "Paiement annulé",
      cancelBody: "Aucun débit n'a été effectué. Votre demande est enregistrée — vous pouvez payer l'acompte à tout moment.",
      failed: "Nous n'avons pas pu confirmer ce paiement pour le moment. Si vous l'avez effectué, réessayez dans une minute.",
      backHome: "Retour à l'accueil"
    },
    errors: {
      required: "Ce champ est requis",
      email: "Veuillez saisir une adresse e-mail valide",
      phone: "Veuillez saisir un numéro de téléphone valide",
      license: "Veuillez saisir au moins 4 caractères",
      experience: "Saisissez un nombre entre 0 et 60",
      generic: "Une erreur est survenue. Veuillez réessayer."
    },
    footer: {
      tagline: "Service de chauffeur électrique premium. Anvers.",
      navigate: "Naviguer",
      servicesTitle: "Services",
      contactTitle: "Contact",
      rights: "Tous droits réservés."
    }
  },

  nl: {
    nav: {
      home: "Home", about: "Over Ons", fleet: "Onze Vloot", services: "Diensten",
      driver: "Chauffeur Worden", contact: "Contact",
      contactCta: "Contact opnemen", driverCta: "Word chauffeur"
    },
    blog: {
      eyebrow: "Journal", title: "Notities van onderweg",
      sub: "Korte verhalen over premium elektrische mobiliteit in Antwerpen.",
      readMore: "Lees", back: "Alle artikelen", minRead: "min lezen"
    },
    whatsapp: {
      aria: "Chat via WhatsApp",
      message: "Hallo MIRAL GROUP, ik wil graag een rit boeken."
    },
    hero: {
      badge: "100% elektrisch · Nul emissie · Antwerpen VIP-chauffeur",
      line1: "Gedreven door innovatie.",
      line2: "Ontworpen voor uw reis.",
      sub: "MIRAL GROUP herdefinieert premium mobiliteit in Antwerpen: een 100% elektrische Tesla-vloot, chauffeurs opgeleid in protocol en absolute discretie.",
      ctaContact: "Contact opnemen",
      ctaDriver: "Word chauffeur",
      stats: [
        { v: "100%", l: "Elektrische vloot" },
        { v: "629 km", l: "Max. actieradius WLTP" },
        { v: "4,4s", l: "0–100 km/u" },
        { v: "24/24", l: "Concierge-dispatch" }
      ]
    },
    marquee: ["Luchthaven Brussel", "Europese wijk", "Grote Markt", "Zero-emissie luxe", "Tesla Model 3", "Tesla Model Y", "Concierge 24/24"],
    home: {
      fleetEyebrow: "Onze vloot",
      fleetTitle: "Tesla. Stilte is de nieuwe luxe.",
      fleetSub: "Twee modellen, één standaard: compromisloos elektrisch comfort voor de veeleisende reiziger.",
      fleetCta: "Ontdek de vloot",
      servicesEyebrow: "Diensten",
      servicesTitle: "Elke rit, tot in detail ontworpen.",
      servicesSub: "Van EU-institutionele transfers tot privéavonden: elke rit volgt het MIRAL-protocol.",
      estEyebrow: "Tariefindicatie",
      estTitle: "Bereken uw rit",
      estSub: "Kies een route en een voertuig voor een indicatieve prijs. Definitieve offerte op aanvraag.",
      estNote: "Indicatieve tarieven — de definitieve offerte wordt door onze concierge bevestigd.",
      estCta: "Deze rit aanvragen",
      routes: {
        bru: "Antwerpen ↔ Luchthaven Brussel (BRU)",
        crl: "Antwerpen ↔ Luchthaven Charleroi (CRL)",
        hourly: "Uurbasis (min. 3u)"
      },
      vehicle3: "Model 3",
      vehicleY: "Model Y",
      hourlyUnit: "/uur",
      bannerEyebrow: "Carrières",
      bannerTitle: "Rijd mee met de toekomst van Antwerpen.",
      bannerSub: "Word chauffeur bij een premium huis. Tesla voorzien, voortreffelijke klanten, flexibele uren.",
      bannerCta: "Solliciteer nu"
    },
    about: {
      eyebrow: "Over ons",
      title: "Antwerpen, met klasse.",
      lead: "MIRAL GROUP is gebouwd op één overtuiging: door een hoofdstad bewegen moet moeiteloos, geruisloos en volledig persoonlijk aanvoelen.",
      p1: "Van de Grote Markt tot de Europese wijk: onze chauffeurs kennen elke straat, elke ingang, elk ritme. Achter het stuur van een 100% elektrische Tesla-vloot volgen zij één norm: die van u.",
      p2: "Geen verbranding, geen geluid, geen compromis. Alleen het stille vertrouwen van een huis dat elke rit behandelt als een handtekening.",
      missionEyebrow: "Onze missie",
      missionTitle: "Nul emissie. Volle aandacht.",
      missionText: "Wij rijden met één van de eerste volledig Tesla chauffeursvloten van Antwerpen. Elke rit is een stap naar schonere lucht in de stad die we liefhebben — zonder ook maar iets aan comfort in te leveren.",
      standardsEyebrow: "Executive standaarden",
      standards: [
        { t: "Chauffeurs opgeleid in protocol", d: "Meertalig, discreet, opgeleid volgens diplomatieke standaarden." },
        { t: "Realtime dispatch, 24/24", d: "Onze concierge bewaakt elke vlucht en elke route." },
        { t: "Absolute privacy", d: "Wat aan boord wordt gezegd, blijft aan boord." },
        { t: "Onberispelijk, elke keer", d: "Elke Tesla wordt voor elke rit geprepareerd en gecontroleerd." }
      ]
    },
    fleetPage: {
      eyebrow: "Onze vloot",
      title: "Twee silhouetten. Eén handtekening.",
      sub: "Ontdek de MIRAL-vloot in detail — actieradius, tempo en comfort, rond u ontworpen.",
      bookCta: "Dit model boeken",
      compareEyebrow: "Naast elkaar",
      compareTitle: "Kies uw silhouet",
      labels: { range: "Actieradius · WLTP", accel: "0–100 km/u", seats: "Passagiers", luggage: "Bagage", drive: "Aandrijving", features: "Signature opties" },
      models: {
        m3: {
          name: "Tesla Model 3 Highland",
          category: "Executive Sedan",
          drive: "Dual Motor AWD",
          desc: "De Highland, de nieuwe maatstaf voor de executive sedan — geslepen, fluisterstil en verrassend snel. Dé stadsberline voor Antwerpen.",
          features: ["Panoramisch glasdak", "Premium audio", "Tri-zone klimaatregeling", "Verwarmde zetels"]
        },
        my: {
          name: "Tesla Model Y Long Range",
          category: "Premium SUV",
          drive: "Dual Motor AWD",
          desc: "Ruimte zonder compromis: een panoramische SUV voor delegaties, gezinnen en veel bagage, met hetzelfde stille MIRAL-protocol aan boord.",
          features: ["Panoramisch glasdak", "Premium audio", "HEPA-filter", "Verwarmde achterzetels"]
        }
      }
    },
    servicesPage: {
      eyebrow: "Diensten",
      title: "Elke rit, tot in detail ontworpen.",
      sub: "Vier disciplines, één protocol: absolute precisie van het eerste bericht tot aan de laatste drempel.",
      items: [
        { id: "airport", title: "Luchthavenchauffeur", desc: "Verwelkoming op Luchthaven Brussel (BRU) en Charleroi (CRL), met live vluchtvolging en inbegrepen wachttijd." },
        { id: "eu", title: "Diplomatiek & EU-vervoer", desc: "Discreet vervoer voor delegaties en instellingen rond de Europese wijk, met meertalige chauffeurs opgeleid in protocol." },
        { id: "corporate", title: "Zakelijke abonnementen", desc: "Toegewijde voertuigen en prioritaire dispatch voor bestuurders en teams, met geconsolideerde maandfacturatie." },
        { id: "events", title: "Huwelijken & VIP-evenementen", desc: "Tesla-service met witte handschoenen voor privévieringen, gala's en avonden met rode loper in heel België." }
      ],
      processEyebrow: "Het protocol",
      processTitle: "Drie stappen. Nul wrijving.",
      steps: [
        { title: "Boek binnen enkele seconden", desc: "Online, telefonisch of via uw concierge — 24/24." },
        { title: "Ontmoet uw chauffeur", desc: "Vluchtvolging, naambord, bagage geregeld." },
        { title: "Kom uitgerust aan", desc: "Stil, soepel, stipt op tijd." }
      ],
      ctaTitle: "Vertel ons waar en wanneer.",
      ctaSub: "Onze concierge antwoordt binnen enkele minuten, dag en nacht.",
      ctaButton: "Contact opnemen"
    },
    driver: {
      eyebrow: "Carrières",
      title: "Neem het stuur van uw carrière.",
      sub: "Sluit u aan bij het huis dat Antwerpen stil maakte. Tesla voorzien, voortreffelijke klanten, flexibele uren.",
      benefitsTitle: "Waarom MIRAL",
      benefits: [
        "Een Tesla, door ons voorzien en onderhouden",
        "Premium klanten: ambassades, EU-instellingen, luxehotels",
        "Flexibele uren die rond uw leven passen",
        "Continue opleiding, transparante inkomsten"
      ],
      reqTitle: "Voorwaarden",
      reqs: [
        "Geldig rijbewijs (categorie B)",
        "Professioneel taxivergunning of chauffeurslicentie — of de wil om die te behalen",
        "Vlot in het Frans en/of Nederlands; Engels is een pluspunt",
        "Onberispelijk gedrag en professionele uitstraling",
        "Comfortabel om de MIRAL-standaard uit te dragen"
      ],
      formTitle: "Chauffeursollicitatie",
      formSub: "Vul het onderstaande formulier in — ons team antwoordt binnen 48 uur.",
      form: {
        fullName: "Volledige naam",
        email: "E-mail",
        phone: "Telefoon",
        city: "Stad",
        license: "Rijbewijsnummer",
        experience: "Jaren ervaring",
        languages: "Gesproken talen",
        languagesPh: "bv. Frans, Nederlands, Engels",
        notes: "Opmerkingen (optioneel)",
        notesPh: "Beschikbaarheid, certificaten, verder…",
        submit: "Sollicitatie versturen",
        successTitle: "Sollicitatie ontvangen",
        successBody: "Bedankt! Ons team neemt binnen 48 uur contact op.",
        ref: "Referentie",
        again: "Nieuwe sollicitatie versturen"
      },
      faqTitle: "Veelgestelde vragen",
      faq: [
        { q: "Heb ik een eigen voertuig nodig?", a: "Nee. Uw Tesla wordt door MIRAL GROUP voorzien en onderhouden." },
        { q: "Welke talen heb ik nodig?", a: "Frans of Nederlands is vereist; Engels is een sterk pluspunt voor onze internationale klanten." },
        { q: "Hoe verloopt de selectie?", a: "Solliciteer via het formulier, daarna volgen een interview en een rijevaluatie met ons operationeel team." },
        { q: "Kan ik mijn uren kiezen?", a: "Ja. Wij bouwen de planning rond uw beschikbaarheid." }
      ]
    },
    contact: {
      eyebrow: "Contact",
      title: "Plan wij uw reis.",
      sub: "Vertel ons waar en wanneer — onze concierge bevestigt elk detail.",
      infoTitle: "Direct contact",
      office: "Kantoor",
      phoneLabel: "Telefoon",
      emailLabel: "E-mail",
      dispatchLabel: "Concierge",
      dispatchValue: "24/24 — telefoon & e-mail",
      mapTitle: "Vind ons in Antwerpen",
      mapSub: "Kantoor in de stad en welkomstzone op de luchthaven.",
      markerHqTitle: "MIRAL GROUP — Kantoor",
      markerHqSub: "Antwerpen centrum",
      markerAirportTitle: "Luchthaven Brussel (BRU)",
      markerAirportSub: "Meet & greet zone",
      formTitle: "Een rit aanvragen",
      form: {
        name: "Volledige naam",
        email: "E-mail",
        phone: "Telefoon",
        service: "Type dienst",
        pickup: "Ophaallocatie",
        pickupPh: "Adres, hotel of terminal",
        dest: "Bestemming (optioneel)",
        destPh: "Adres of luchthaven",
        datetime: "Datum & uur van ophalen",
        notes: "Bericht (optioneel)",
        notesPh: "Passagiers, bagage, speciale wensen…",
        submit: "Aanvraag versturen",
        successTitle: "Aanvraag verzonden",
        successBody: "Onze concierge bevestigt binnenkort de details.",
        ref: "Referentie",
        again: "Nieuwe aanvraag versturen"
      },
      serviceOptions: {
        airport: "Luchthaventransfer (BRU / CRL)",
        eu: "Diplomatiek & EU-vervoer",
        corporate: "Zakelijk abonnement",
        events: "Huwelijken & VIP-evenementen",
        other: "Andere aanvraag"
      }
    },
    auth: {
      signIn: "Inloggen", createAccount: "Account aanmaken", welcomeBack: "Welkom terug", joinUs: "Word lid van MIRAL GROUP",
      loginSub: "Bekijk uw boekingen en betalingen.", registerSub: "Eén account voor boekingen, ontvangsten en prioriteitsservice.",
      fullName: "Volledige naam", email: "E-mail", phone: "Telefoon (optioneel)", password: "Wachtwoord", passwordHint: "Minimaal 8 tekens",
      loginBtn: "Inloggen", registerBtn: "Mijn account aanmaken",
      noAccount: "Nog geen account? Maak er een aan", haveAccount: "Heeft u al een account? Log in",
      googleBtn: "Doorgaan met Google", or: "of",
      myAccount: "Mijn account", myRequests: "Mijn ritaanvragen", noRequests: "Nog geen ritaanvragen — boek uw eerste rit.",
      logout: "Uitloggen", hello: "Hallo", bookCta: "Boek een rit",
      errors: { invalidCreds: "Ongeldig e-mailadres of wachtwoord", emailUsed: "Er bestaat al een account met dit e-mailadres", weakPassword: "Wachtwoord moet minstens 8 tekens bevatten", nameRequired: "Voer uw naam in" },
      forgotLink: "Wachtwoord vergeten?", forgotTitle: "Wachtwoord resetten", forgotSub: "Voer uw e-mail in — wij sturen u een resetlink.",
      forgotBtn: "Link versturen", forgotSent: "Bestaat er een account voor dit e-mailadres, dan is er een link onderweg.",
      newPassword: "Nieuw wachtwoord", confirmPassword: "Bevestig wachtwoord", resetBtn: "Opslaan",
      resetDone: "Wachtwoord bijgewerkt — u kunt nu inloggen.", mismatch: "Wachtwoorden komen niet overeen",
      invalidLink: "Deze link is ongeldig of verlopen. Vraag een nieuwe aan.", backToLogin: "Terug naar inloggen",
      cols: ["Datum", "Dienst", "Ophalen", "Bestemming", "Status", "Betaling"]
    },
    admin: {
      title: "Boekingen & sollicitaties", loginTitle: "Adminpaneel", loginSub: "Alleen voor MIRAL GROUP-medewerkers.",
      email: "E-mail", password: "Wachtwoord", signIn: "Inloggen", refresh: "Verversen", backHome: "← Terug naar website",
      empty: "Nog geen vermeldingen.", loading: "LADEN…",
      tabs: { drivers: "Chauffeursollicitaties", requests: "Ritaanvragen", payments: "Betalingen" },
      actions: { approve: "Goedkeuren", reject: "Afwijzen", decisionSent: "Kandidaat geïnformeerd", colActions: "Acties" },
      cols: {
        drivers: ["Ontvangen", "Naam", "Contact", "Stad", "Rijbewijs", "Ervaring", "Talen", "Status", "Acties"],
        contacts: ["Ontvangen", "Naam", "Contact", "Dienst", "Ophalen", "Bestemming", "Wanneer", "Betaling"],
        payments: ["Datum", "Sessie", "Boekingsref", "Bedrag", "Status"]
      }
    },
    pay: {
      depositTitle: "Bevestig uw boeking",
      depositBody: "Betaal de aanbetaling van €20 om uw rit veilig te stellen — het saldo wordt met uw chauffeur afgerekend.",
      depositBtn: "Betaal €20 aanbetaling",
      paying: "Doorverwijzen naar beveiligde afrekening…",
      processing: "Uw betaling wordt gecontroleerd…",
      successTitle: "Betaling bevestigd",
      successBody: "Uw aanbetaling is ontvangen. Onze concierge bevestigt de laatste details.",
      cancelTitle: "Betaling geannuleerd",
      cancelBody: "Er is niets afgeschreven. Uw aanvraag is opgeslagen — u kunt de aanbetaling altijd later betalen.",
      failed: "We konden deze betaling nog niet bevestigen. Heeft u betaald? Kijk over een minuut opnieuw.",
      backHome: "Terug naar home"
    },
    errors: {
      required: "Dit veld is verplicht",
      email: "Voer een geldig e-mailadres in",
      phone: "Voer een geldig telefoonnummer in",
      license: "Voer minstens 4 tekens in",
      experience: "Voer een getal in tussen 0 en 60",
      generic: "Er ging iets mis. Probeer het opnieuw."
    },
    footer: {
      tagline: "Premium elektrische chauffeursdienst. Antwerpen.",
      navigate: "Navigeren",
      servicesTitle: "Diensten",
      contactTitle: "Contact",
      rights: "Alle rechten voorbehouden."
    }
  },

  ar: {
    nav: {
      home: "الرئيسية", about: "من نحن", fleet: "أسطولنا", services: "خدماتنا",
      driver: "انضم كسائق", contact: "تواصل معنا",
      contactCta: "تواصل معنا", driverCta: "كن سائقاً"
    },
    blog: {
      eyebrow: "المدونة", title: "مذكرات من الطريق",
      sub: "قراءات قصيرة عن التنقل الكهربائي الفاخر في انتويرب.",
      readMore: "اقرأ", back: "كل المقالات", minRead: "دقائق قراءة"
    },
    whatsapp: {
      aria: "تواصل عبر واتساب",
      message: "مرحباً ميرال غروب، أود حجز مشوار."
    },
    hero: {
      badge: "100% كهربائي · صفر انبعاثات · سائق VIP في انتويرب",
      line1: "يقودنا الابتكار.",
      line2: "مُصمَّم لرحلتك.",
      sub: "ميرال غروب تعيد تعريف التنقل الفاخر في انتويرب — أسطول تسلا كهربائي 100% وسائقون مدربون على البروتوكول وسرية مطلقة.",
      ctaContact: "تواصل معنا",
      ctaDriver: "كن سائقاً",
      stats: [
        { v: "100%", l: "أسطول كهربائي" },
        { v: "629 كم", l: "أقصى مدى WLTP" },
        { v: "4.4 ث", l: "0–100 كم/س" },
        { v: "24/24", l: "كونسيرج جاهز دائماً" }
      ]
    },
    marquee: ["مطار بروكسل", "الحي الأوروبي", "الساحة الكبرى", "فخامة بلا انبعاثات", "تسلا موديل 3", "تسلا موديل Y", "كونسيرج 24/24"],
    home: {
      fleetEyebrow: "أسطولنا",
      fleetTitle: "تسلا. الصمت هو الفخامة الجديدة.",
      fleetSub: "موديلان، معيار واحد: راحة كهربائية بلا مساومة للمسافر الباحث عن التميّز.",
      fleetCta: "اكتشف الأسطول",
      servicesEyebrow: "خدماتنا",
      servicesTitle: "كل رحلة مصممة بإتقان.",
      servicesSub: "من رحلات المؤسسات الأوروبية إلى الأمسيات الخاصة، كل مشوار يتبع بروتوكول ميرال.",
      estEyebrow: "حاسبة الأجرة",
      estTitle: "قدّر تكلفة رحلتك",
      estSub: "اختر الوجهة والمركبة لأجرة استرشادية. العرض النهائي عند الطلب.",
      estNote: "أجور استرشادية — يؤكد الكونسيرج العرض النهائي.",
      estCta: "اطلب هذه الرحلة",
      routes: {
        bru: "انتويرب ↔ مطار بروكسل (BRU)",
        crl: "انتويرب ↔ مطار شارلروا (CRL)",
        hourly: "تصريف بالساعة (٣ ساعات كحد أدنى)"
      },
      vehicle3: "موديل 3",
      vehicleY: "موديل Y",
      hourlyUnit: "/ساعة",
      bannerEyebrow: "الوظائف",
      bannerTitle: "قُد مستقبل انتويرب.",
      bannerSub: "انضم إلى بيت السائقين الفاخر. تسلا متوفرة لك، عملاء من الطراز الرفيع، دوامات مرنة.",
      bannerCta: "قدّم الآن"
    },
    about: {
      eyebrow: "من نحن",
      title: "انتويرب، برقيّ أعلى.",
      lead: "بُنيت ميرال غروب على قناعة بسيطة: أن يكون التنقل في العاصمة سلساً وصامتاً وشخصياً تماماً.",
      p1: "من الساحة الكبرى إلى الحي الأوروبي، يعرف سائقونا كل شارع وكل مدخل وكل توقيت. وخلف مقود أسطول تسلا الكهربائي 100%، لا يتبعون سوى معيار واحد: معيارك أنت.",
      p2: "لا احتراق، لا ضجيج، لا مساومة. فقط الثقة الهادئة لبيتٍ يتعامل مع كل رحلة كتوقيعٍ خاص.",
      missionEyebrow: "مهمتنا",
      missionTitle: "صفر انبعاثات. اهتمام كامل.",
      missionText: "نشغّل أحد أوائل أساطيل السائقين الكهربائية بالكامل من تسلا في انتويرب. كل رحلة خطوة نحو هواء أنظف في المدينة التي نحبها — دون أن نتنازل عن شبرٍ من الراحة.",
      standardsEyebrow: "معايير التميّز",
      standards: [
        { t: "سائقون مدربون على البروتوكول", d: "متعددو اللغات، كتومون، مدربون على المعايير الدبلوماسية." },
        { t: "توجيه فوري، 24/24", d: "يراقب كونسيرجنا كل رحلة جوية وكل طريق." },
        { t: "خصوصية مطلقة", d: "ما يُقال في السيارة يبقى في السيارة." },
        { t: "نظافة تامة في كل مرة", d: "كل سيارة تسلا تُجهَّز وتُفحص قبل كل مشوار." }
      ]
    },
    fleetPage: {
      eyebrow: "أسطولنا",
      title: "خطّان. توقيعٌ واحد.",
      sub: "اكتشف أسطول ميرال بالتفصيل — المدى والأداء والراحة، مصممة من حولك.",
      bookCta: "احجز هذا الموديل",
      compareEyebrow: "جنباً إلى جنب",
      compareTitle: "اختر طرازك",
      labels: { range: "المدى · WLTP", accel: "0–100 كم/س", seats: "الركاب", luggage: "الأمتعة", drive: "نظام الدفع", features: "تجهيزات مميزة" },
      models: {
        m3: {
          name: "تسلا موديل 3 هايلاند",
          category: "سيدان تنفيذية",
          drive: "محركان AWD",
          desc: "هايلاند الجديدة، المرجع المطلق لفئة السيدان التنفيذية — منحوتة، هادئة همساً، وسريعة بشكل مدهش. السيدان الأفضل لشوارع انتويرب.",
          features: ["سقف زجاجي بانورامي", "نظام صوتي فاخر", "تكييف ثلاثي المناطق", "مقاعد مدفأة"]
        },
        my: {
          name: "تسلا موديل Y لونغ رينج",
          category: "SUV فاخرة",
          drive: "محركان AWD",
          desc: "مساحة بلا مساومة: SUV بانورامية للوفود والعائلات والوصول بأمتعة كثيرة، مع بروتوكول ميرال الهادئ نفسه.",
          features: ["سقف زجاجي بانورامي", "نظام صوتي فاخر", "فلتر HEPA", "مقاعد خلفية مدفأة"]
        }
      }
    },
    servicesPage: {
      eyebrow: "خدماتنا",
      title: "كل رحلة مصممة بإتقان.",
      sub: "أربعة تخصصات، بروتوكول واحد: دقة مطلقة من أول رسالة حتى عتبة الباب الأخيرة.",
      items: [
        { id: "airport", title: "سائق المطارات", desc: "استقبال في مطار بروكسل (BRU) وشارلروا (CRL)، مع تتبع مباشر للرحلات ووقت انتظار مشمول." },
        { id: "eu", title: "نقل دبلوماسي وأوروبي", desc: "نقل كتوم للوفود والمؤسسات حول الحي الأوروبي، مع سائقين متعددي اللغات مدربين على البروتوكول." },
        { id: "corporate", title: "اشتراكات الشركات", desc: "مركبات مخصصة وتوجيه ذو أولوية للمديرين والفرق، مع فوترة شهرية موحدة." },
        { id: "events", title: "أعراس وفعاليات VIP", desc: "خدمة تسلا بالقفازات البيضاء للاحتفالات الخاصة والحفلات والسهرات الفاخرة في بلجيكا كلها." }
      ],
      processEyebrow: "البروتوكول",
      processTitle: "ثلاث خطوات. صفر احتكاك.",
      steps: [
        { title: "احجز في ثوانٍ", desc: "أونلاين أو هاتفياً أو عبر الكونسيرج — 24/24." },
        { title: "قابل سائقك", desc: "تتبع الرحلة، لوحة اسم، والأمتعة مُتكفَّل بها." },
        { title: "صِل منتعشاً", desc: "صامت، سلس، في الموعد تماماً." }
      ],
      ctaTitle: "أخبرنا أين ومتى.",
      ctaSub: "يجيب كونسيرجنا خلال دقائق، ليلاً ونهاراً.",
      ctaButton: "تواصل معنا"
    },
    driver: {
      eyebrow: "الوظائف",
      title: "تولَّ مقود مسيرتك المهنية.",
      sub: "انضم إلى البيت الذي جعل انتويرب صامتة. تسلا متوفرة لك، عملاء رفيعو المستوى، دوامات مرنة.",
      benefitsTitle: "لماذا ميرال",
      benefits: [
        "سيارة تسلا نوفرها ونعتني بها",
        "عملاء مميزون: سفارات ومؤسسات أوروبية وفنادق فاخرة",
        "دوامات مرنة تناسب حياتك",
        "تدريب مستمر ودخل شفاف"
      ],
      reqTitle: "الشروط",
      reqs: [
        "رخصة قيادة سارية (الفئة B)",
        "رخصة تاكسي أو سائق محترف — أو الاستعداد للحصول عليها",
        "إتقان الفرنسية و/أو الهولندية؛ الإنجليزية ميزة إضافية",
        "سلوك لا تشوبه شائبة ومظهر مهني",
        "القدرة على تمثيل معيار ميرال"
      ],
      formTitle: "طلب توظيف سائق",
      formSub: "أكمل النموذج أدناه — يرد فريقنا خلال 48 ساعة.",
      form: {
        fullName: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        city: "المدينة",
        license: "رقم رخصة القيادة",
        experience: "سنوات الخبرة",
        languages: "اللغات التي تتحدثها",
        languagesPh: "مثال: الفرنسية، الهولندية، الإنجليزية",
        notes: "ملاحظات (اختياري)",
        notesPh: "التفرغ، الشهادات، أي شيء آخر…",
        submit: "أرسل الطلب",
        successTitle: "تم استلام طلبك",
        successBody: "شكراً لك! سيتواصل فريقنا معك خلال 48 ساعة.",
        ref: "المرجع",
        again: "أرسل طلباً آخر"
      },
      faqTitle: "أسئلة شائعة",
      faq: [
        { q: "هل أحتاج سيارتي الخاصة؟", a: "لا. سيارتك التسلا توفرها ميرال غروب وتعتني بها." },
        { q: "ما اللغات المطلوبة؟", a: "الفرنسية أو الهولندية مطلوبة؛ والإنجليزية ميزة قوية لعملائنا الدوليين." },
        { q: "كيف تتم عملية الاختيار؟", a: "قدّم عبر النموذج، ثم مقابلة وتقييم قيادة مع فريق العمليات." },
        { q: "هل أختار دواماتي؟", a: "نعم. نبني الجداول حول تفرغك." }
      ]
    },
    contact: {
      eyebrow: "تواصل معنا",
      title: "لنخطط لرحلتك.",
      sub: "أخبرنا أين ومتى — يؤكد كونسيرجنا كل التفاصيل.",
      infoTitle: "تواصل مباشر",
      office: "المكتب",
      phoneLabel: "الهاتف",
      emailLabel: "البريد الإلكتروني",
      dispatchLabel: "الكونسيرج",
      dispatchValue: "24/24 — هاتف وبريد",
      mapTitle: "اعثر علينا في انتويرب",
      mapSub: "مكتب المدينة ومنطقة الاستقبال في المطار.",
      markerHqTitle: "ميرال غروب — المكتب",
      markerHqSub: "وسط انتويرب",
      markerAirportTitle: "مطار بروكسل (BRU)",
      markerAirportSub: "منطقة الاستقبال",
      formTitle: "اطلب رحلة",
      form: {
        name: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        service: "نوع الخدمة",
        pickup: "نقطة الانطلاق",
        pickupPh: "عنوان أو فندق أو محطة",
        dest: "الوجهة (اختياري)",
        destPh: "عنوان أو مطار",
        datetime: "تاريخ ووقت الانطلاق",
        notes: "رسالة (اختياري)",
        notesPh: "الركاب، الأمتعة، طلبات خاصة…",
        submit: "أرسل الطلب",
        successTitle: "تم إرسال الطلب",
        successBody: "سيؤكد الكونسيرج التفاصيل قريباً.",
        ref: "المرجع",
        again: "أرسل طلباً آخر"
      },
      serviceOptions: {
        airport: "نقل من/إلى المطار (BRU / CRL)",
        eu: "نقل دبلوماسي وأوروبي",
        corporate: "اشتراك شركات",
        events: "أعراس وفعاليات VIP",
        other: "طلب آخر"
      }
    },
    auth: {
      signIn: "تسجيل الدخول", createAccount: "إنشاء حساب", welcomeBack: "مرحباً بعودتك", joinUs: "انضم إلى ميرال غروب",
      loginSub: "اطّلع على حجوزاتك ومدفوعاتك.", registerSub: "حساب واحد للحجوزات والإيصالات والدعم ذي الأولوية.",
      fullName: "الاسم الكامل", email: "البريد الإلكتروني", phone: "الهاتف (اختياري)", password: "كلمة المرور", passwordHint: "8 أحرف على الأقل",
      loginBtn: "تسجيل الدخول", registerBtn: "أنشئ حسابي",
      noAccount: "ليس لديك حساب؟ أنشئ واحداً", haveAccount: "لديك حساب بالفعل؟ سجّل دخولك",
      googleBtn: "المتابعة عبر Google", or: "أو",
      myAccount: "حسابي", myRequests: "طلبات رحلاتي", noRequests: "لا توجد طلبات بعد — احجز رحلتك الأولى.",
      logout: "تسجيل الخروج", hello: "مرحباً", bookCta: "احجز رحلة",
      errors: { invalidCreds: "البريد أو كلمة المرور غير صحيحة", emailUsed: "يوجد حساب مسجّل بهذا البريد", weakPassword: "كلمة المرور يجب أن تكون 8 أحرف على الأقل", nameRequired: "أدخل اسمك" },
      forgotLink: "نسيت كلمة المرور؟", forgotTitle: "إعادة تعيين كلمة المرور", forgotSub: "أدخل بريدك — سنرسل لك رابط إعادة التعيين.",
      forgotBtn: "أرسل الرابط", forgotSent: "إن كان لهذا البريد حساب، فالرابط في طريقه إليك.",
      newPassword: "كلمة المرور الجديدة", confirmPassword: "تأكيد كلمة المرور", resetBtn: "احفظ كلمة المرور",
      resetDone: "تم تحديث كلمة المرور — يمكنك الدخول الآن.", mismatch: "كلمتا المرور غير متطابقتين",
      invalidLink: "هذا الرابط غير صالح أو منتهي. اطلب رابطاً جديداً.", backToLogin: "عودة لتسجيل الدخول",
      cols: ["التاريخ", "الخدمة", "الانطلاق", "الوجهة", "الحالة", "الدفع"]
    },
    admin: {
      title: "الحجوزات والطلبات", loginTitle: "لوحة الإدارة", loginSub: "مخصصة لفريق ميرال غروب فقط.",
      email: "البريد الإلكتروني", password: "كلمة المرور", signIn: "تسجيل الدخول", refresh: "تحديث", backHome: "← عودة للموقع",
      empty: "لا توجد مدخلات بعد.", loading: "جارٍ التحميل…",
      tabs: { drivers: "طلبات السائقين", requests: "طلبات الرحلات", payments: "المدفوعات" },
      actions: { approve: "اعتماد", reject: "رفض", decisionSent: "تم إشعار المتقدم", colActions: "إجراءات" },
      cols: {
        drivers: ["الاستلام", "الاسم", "التواصل", "المدينة", "الرخصة", "الخبرة", "اللغات", "الحالة", "إجراءات"],
        contacts: ["الاستلام", "الاسم", "التواصل", "الخدمة", "الانطلاق", "الوجهة", "متى", "الدفع"],
        payments: ["التاريخ", "الجلسة", "مرجع الحجز", "المبلغ", "الحالة"]
      }
    },
    pay: {
      depositTitle: "أكّد حجزك",
      depositBody: "ادفع عربون الحجز €20 لتأمين رحلتك — ويُسوَّى الباقي مع سائقك.",
      depositBtn: "ادفع العربون €20",
      paying: "جارٍ التحويل للدفع الآمن…",
      processing: "نتحقق من دفعتك…",
      successTitle: "تم تأكيد الدفع",
      successBody: "استلمنا عربون حجزك. سيؤكد الكونسيرج التفاصيل النهائية.",
      cancelTitle: "تم إلغاء الدفع",
      cancelBody: "لم يُخصم أي مبلغ. طلب رحلتك محفوظ — ويمكنك دفع العربون في أي وقت.",
      failed: "تعذّر تأكيد الدفع حالياً. إن كنت قد دفعت، تحقق بعد دقيقة.",
      backHome: "عودة للرئيسية"
    },
    errors: {
      required: "هذا الحقل مطلوب",
      email: "أدخل بريداً إلكترونياً صحيحاً",
      phone: "أدخل رقم هاتف صحيحاً",
      license: "أدخل 4 أحرف على الأقل",
      experience: "أدخل رقماً بين 0 و 60",
      generic: "حدث خطأ ما. حاول مجدداً."
    },
    footer: {
      tagline: "خدمة سائق كهربائية فاخرة. انتويرب.",
      navigate: "التنقل",
      servicesTitle: "الخدمات",
      contactTitle: "التواصل",
      rights: "جميع الحقوق محفوظة."
    }
  }
};
